type Props = {
    active: boolean;
    className?: string;
    activeClassName?: string;
};

const ActivityIndicator = (props: Props) => (
    <div
        data-testid="ActivityIndicator"
        className={props.className + " ActivityIndicator " + (props.active ? props.activeClassName || "d-inline-flex" : "d-none")}>
        <i className={"fas fa-sync fa-spin"} />
    </div>
);

export default ActivityIndicator;
